<template>
    <div tabindex="-1">
        <div class="modal" tabindex="0" @click.self="close" v-if="openModalName == name" :class="openModalName">
            <div class="modal__content" :class="classContent">
                <div class="modal-close" @click="close" v-if="closable" v-insert-area="{ horizontal: 'center', vertical: 'center' }">
                    <div class="modal-close-icon"></div>
                </div>
                <header v-if="hasHeader">
                    <h4 class="modal-title">
                        <slot name="header"></slot>
                    </h4>
                </header>
                <div class="modal-main">
                    <div class="modal-main__spinner" v-show="showContentSpinner">
                        <svg class="modal-main__spinner-image" xmlns="http://www.w3.org/2000/svg" viewBox="-20 -20 40 40">
                            <circle r="16" />
                        </svg>
                    </div>
                    <slot></slot>
                </div>
                <footer v-if="hasFooter && !showContentSpinner">
                    <slot name="footer"></slot>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'modal',
    props: {
        name: null,
        closable: {
            type: Boolean,
            default: true
        },
        classContent: {
            type: String,
            default: ''
        },
        showContentSpinner: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        openModalName() {
            return this.$store.state.modals.name;
        },
        hasHeader() {
            return !!this.$slots.header;
        },
        hasFooter() {
            return !!this.$slots.footer;
        }
    },
    created() {},
    methods: {
        close() {
            if (!this.closable) return;
            this.$router.push({ path: '', query: this.$route.query });
        },
        focusModal() {
            this.$el.focus();
        }
    },
    watch: {
        openModalName(newValue, oldValue) {
            if (newValue == this.name) {
                this.$emit('open');
                this.focusModal();
            }
            if (oldValue == this.name) {
                const eventArg = { suppress: false };
                this.$emit('close', eventArg);
            }
        }
    },
    mounted() {
        if (this.openModalName === this.name) {
            this.$emit('open');
            this.focusModal();
        }
    }
};
</script>

<style lang="scss" src="./modal.scss"></style>



// WEBPACK FOOTER //
// front/src/skins/xkiosk/components/_base/modal/modal.vue